import React from 'react';
import { Box, Container, Grid, Typography, Paper, List, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { Phone, Email, LocationOn, Payment } from '@mui/icons-material';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import { DirectionsCar, Work, Gavel } from '@mui/icons-material';

const MapComponent = () => {
  const [showInfo, setShowInfo] = React.useState(false);
  const center = {
    lat: 37.43104420550252,
    lng: -121.90875984459626
  };
  
  const mapStyles = {
    height: "450px",
    width: "100%"
  };

  const options = {
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: true,
    streetViewControl: true,
    mapTypeId: 'roadmap'
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyAsX_pJFLWzadTb0CQSedkIDTYFCMmiris">
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={14}
        center={center}
        options={options}
      >
        <Marker 
          position={center}
          onClick={() => setShowInfo(true)}
          visible={true}
        >
          {showInfo && (
            <InfoWindow
              position={center}
              onCloseClick={() => setShowInfo(false)}
            >
              <div>
                <Typography variant="subtitle1">Zen Life Acupuncture</Typography>
                <Typography variant="body2">8 N Abel St, Milpitas, CA 95035</Typography>
              </div>
            </InfoWindow>
          )}
        </Marker>
      </GoogleMap>
    </LoadScript>
  );
};

const InsuranceLogos = () => (
  <Stack direction="row" spacing={2} sx={{ mt: 2, flexWrap: 'wrap', gap: 2 }}>
    <img src="/insurancelogo/aetna.png" alt="Aetna" height="60" />
    <img src="/insurancelogo/bluecross.png" alt="Anthem Blue Cross" height="60" />
    <img src="/insurancelogo/blueshield.jpg" alt="BCBS" height="60" />
    <img src="/insurancelogo/calpers.png" alt="Calpers" height="60" />
    <img src="/insurancelogo/cigna.png" alt="Cigna" height="60" />
    <img src="/insurancelogo/unitedhealthcare.png" alt="United Health Care" height="60" />
  </Stack>
);


const Contact = () => {
  const { t } = useTranslation();  
  return (
    <Container sx={{ py: 8 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="h3" gutterBottom>
          {t('contact.title')}
          </Typography>
          <Paper sx={{ p: 6 }}>
            <List>
              <ListItem>
                <ListItemIcon><LocationOn /></ListItemIcon>
                <ListItemText 
                  primary={t('contact.address.title')}
                  secondary={t('contact.address.value')}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon><Phone /></ListItemIcon>
                <ListItemText 
                  primary={t('contact.phone.title')}
                  secondary={
                    <>
                      {t('contact.phone.regularHours')}<br />
                      {t('contact.phone.afterHours')}
                    </>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemIcon><Email /></ListItemIcon>
                <ListItemText 
                  primary={t('contact.email.title')}
                  secondary="zenlifeacu@gmail.com"
                />
              </ListItem>
              <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <Box sx={{ display: 'flex', width: '100%' }}>
                  <ListItemIcon><Payment /></ListItemIcon>
                  <ListItemText 
                    primary={t('contact.payment.title')}
                    secondary={
                      <>
                        {t('contact.payment.description')}
                        <InsuranceLogos />
                      </>
                    }
                  />
                </Box>
                <Box sx={{ mt: 2, mb: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {t('contact.specializedClaims')}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <DirectionsCar sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography variant="body1">
                      {t('contact.carAccidentClaims')}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Work sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography variant="body1">
                      {t('contact.workersCompClaims')}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Gavel sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography variant="body1">
                      {t('contact.legalReferrals')}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h3" gutterBottom>
          {t('contact.direction')}
          </Typography>
          <Paper sx={{ p: 6 }}>
            <List>
              
              <ListItem sx={{ display: 'block' }}>
                <Box sx={{ height: '450px', width: '100%', mt: 2 }}>
                  <MapComponent />
                </Box>
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Container>
    
  );
};

export default Contact;